import {IomoLuminaire} from './iomoLuminaire';

class IomoWallLuminaire extends IomoLuminaire {
	static designName = 'floor';

	static models = {
		pole: {},
	};

	static modelPatterns = [
		{type: 'pole', pattern: /^Bollard_(?<id>(Medio)|(Piccolo))$/i, storageKeys: ['id']},
	];

	static hasBrackets = false;

	static singleBracket = true;

	static supportLayouts = false;

	static checkCollisions = false;

	static defaultConfig = {
		poleHeight: 1.2,
		numberOfHeads: 1,
		layout: 'none',
	};

	static getPoleId(configValues) {
		return +configValues.poleHeight === 1 ? '5' : '5';
	}

}

export {IomoWallLuminaire};

